
import { defineStore } from 'pinia';
import {
  ref,
  type Ref,
} from 'vue';

export const useSideDrawerStore = defineStore('SideDrawerStore', () => {
  const items: Ref<SidebarItem[]> = ref([]);

  function addSidebarItem(item: SidebarItem) {
    items.value.push(item);
  }

  function removeSidebarItems() {
    items.value = [];
  }


  return {addSidebarItem, removeSidebarItems, items };
});

interface SidebarItem {
  name: string,
}
